<!--
* @description  参数1
* @fileName  cancelShipment
* @author userName
* @date 2024-04-23 15:14:10
!-->
<template>
  <div id="cancelShipment" class="cancelShipment">
    <global-login-dialog v-model="isShow" @close="closeDialog">
      <template v-slot:title>
        <div class="title-first">取消订单</div>
      </template>
      <template v-slot:body>
        <div class="main">
          <div class="one-tip">
            <span>请选择取消订单的原因</span>
          </div>
          <div class="main-list">
            <template v-for="(item,index) in List">
              <div
                :key="index"
                :class="['list-item',{'list-item-active':ActiveList.includes(item.id)}]"
                @click="activeList(item)"
              >

                <div :class="ActiveList.includes(item.id) ?'choose-icon-active':'choose-icon'" />
                <span>{{ item.name }}</span>
              </div>
            </template>
          </div>
          <div class="one-tip">
            <!-- <span>If you paid by credit card, you should see a refund in 5-7 business days.</span> -->
          </div>
        </div>
        <div class="foot">
          <button class="by-Cancel" @click="cancel">取消</button>
          <button class="by-button--primary" @click="confirm">确定</button>
        </div>
      </template>
    </global-login-dialog>
  </div>
</template>

<script>
import GlobalLoginDialog from '../../../../../../components/Dialog/Dialog.vue'
import {
  CancelFBAOrder
} from '../../../../../../api/order.js'
export default {
  name: 'CancelShipment',
  components: {
    GlobalLoginDialog
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      isShow: false,
      List: [{
        id: 1,
        name: '货物信息变更',
        isActive: false
      },
      {
        id: 2,
        name: '已有其他更好的渠道',
        isActive: false
      },
      {
        id: 3,
        name: '重复下单',
        isActive: false
      },
      {
        id: 4,
        name: '费用过期',
        isActive: false
      },
      {
        id: 5,
        name: '货物未准备好',
        isActive: false
      }
      ],
      ActiveList: [],
      data: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    cancel() {
      this.isShow = false
    },
    confirm() {
      var reason = ''
      this.List.forEach(item => {
        if (item.isActive) {
          reason += item.name + ','
        }
      })
      CancelFBAOrder({
        orderNo: this.data.orderNo,
        reason: reason
      }).then(res => {
        if (res.code == 200) {
          this.$emit('confirm')
        }
      })
    },
    // 方法
    init(data) {
      this.data = data
      this.isShow = true
    },
    closeDialog() {
      this.$emit('close', false)
    },
    // 选中
    activeList(item) {
      const isOk = this.ActiveList.includes(item.id)
      if (!isOk) {
        this.List.forEach(res => {
          if (item.id == res.id) {
            this.$set(res, 'isActive', !res.isActive)
            this.ActiveList.push(res.id)
          }
        })
      } else {
        this.$set(item, 'isActive', !item.isActive)
        const index = this.ActiveList.indexOf(item.id)
        if (index !== -1) {
          this.ActiveList.splice(index, 1)
        }
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.cancelShipment {
		position: relative;

		::v-deep .dialog {
			width: 600px;
			padding: 0 16px 1px;

			.dialog__header {
				text-align: left;
			}

			.dialog__body {
				padding: 0;
			}
		}

		.main {
			margin: 17px 0 24px;

			.one-tip {
				text-align: left;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #777777;
				line-height: 22px;
				text-align: left;
			}

			.main-list {
				display: flex;
				align-items: stretch; // 垂直方向，子元素左右等高
				flex-flow: row wrap;
				margin-bottom: 16px;

				.list-item-active {
					background: rgba(51, 112, 255, 0.04) !important;
					border-radius: 8px;
					border: 1px solid rgba(51, 112, 255, 0.24) !important;
				}

				.list-item {
					width: 268px;
					height: 48px;
					line-height: 48px;
					background: rgba(216, 216, 216, 0);
					border-radius: 8px;
					border: 1px solid #DDDDDD;
					margin: 16px 0 0 0;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #777777;
					line-height: 22px;
					text-align: left;
					display: flex;
					align-items: center;

					&:hover {
            cursor: pointer;
						border: 1px solid #AAAAAA;
					}

          &:nth-child(2n) {
            margin-left: 16px;
          }

					.choose-icon {
						width: 16px;
						height: 16px;
						background: #FFFFFF;
						border-radius: 4px;
						border: 1px solid #CCCCCC;
						margin: 16px 8px 16px 16px;
						box-sizing: border-box;
					}

					.choose-icon-active {
						background: url('../../../../../../assets/img/client/icon_success.png');
						background-size: 16px 16px;
						width: 16px;
						height: 16px;
						margin: 16px 8px 16px 16px;
					}
				}
			}
		}

		.foot {
			text-align: right;
			margin: 40px 0 24px 0;

			button:nth-of-type(1) {
        cursor: pointer;
				width: 144px;
				height: 40px;
				background: #FFFFFF;
				border-radius: 4px;
				border: 1px solid #DDDDDD;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #333333;
				line-height: 22px;
				text-align: center;
				margin-right: 16px;
			}

			button:nth-of-type(2) {
        cursor: pointer;
				width: 160px;
				height: 40px;
				border-radius: 4px;
			}
		}
	}
</style>
